import React, { useEffect, useState } from "react";
import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import { BookingReadableTO } from "@/models/detail";
import styles from "../../../styles/booking/booking.module.scss";
import Profile from "../../common/account/Profile";
import CardBooking from "./CardBooking";
import ContentSectionLayout from "./ContentSectionLayout";
import { EButtonBooking } from "../../../models/common/enums";
import Help from "../../playWithUs/Help";
import useBookingData from "../../../utils/queries/hooks/useBookingsData";
import PersonalInfoSection from "./PersonalInfoSection";
import PaymentSection from "./PaymentSection";
import { handleNavigation } from "../../../utils/common/handleNavigation";
import {
    IAccountButtonProps,
    TAccountButtonType,
    TAccountSectionType,
} from "../../../models/account";
import { handleNavigationAccount } from "../../../utils/common/account";

const BookingBody = () => {
    const [bookingData, setBookingData] = useState<TAccountSectionType>({
        title: "Your Bookings",
        sectionType: EButtonBooking.YOURBOOKING,
        tourId: "",
    });

    const { title, sectionType, tourId } = bookingData;

    const handleBookingNavigation = (id: TAccountButtonType) =>
        handleNavigation<TAccountButtonType, TAccountSectionType>(
            id,
            bookingData,
            setBookingData,
            handleNavigationAccount("booking")
        );
    const navigationElement: IAccountButtonProps[] = [
        {
            title: "Your Bookings",
            icon: "icon_bookings.svg",
            onClick: handleBookingNavigation,
            id: EButtonBooking.YOURBOOKING,
            isPrimary: true,
            isSubPrimary: false,
            isActive: false,
            disabled: false,
        },
        {
            title: "General Info",
            icon: "personal_info.svg",
            iconDeactivated: "personal_infoDeactivated.svg",
            onClick: handleBookingNavigation,
            id: EButtonBooking.PERSONALINFO,
            isPrimary: false,
            isSubPrimary: true,
            isActive: sectionType === EButtonBooking.PERSONALINFO,
            disabled: !tourId,
        },
        {
            title: "Payments",
            icon: "payments.svg",
            iconDeactivated: "payments_Deactivated.svg",
            onClick: handleBookingNavigation,
            id: EButtonBooking.PAYMENTS,
            isPrimary: false,
            isSubPrimary: true,
            isActive: sectionType === EButtonBooking.PAYMENTS,
            disabled: !tourId,
        },
    ];

    const handleMethodBooking = (
        titleSection: string,
        buttonId: EButtonBooking,
        idTour: string
    ) => {
        handleBookingNavigation(buttonId);
        setBookingData({
            ...bookingData,
            title: titleSection,
            sectionType: buttonId,
            tourId: idTour,
        });
    };

    const { data: bookings } = useBookingData();

    const bookingSelected = bookings?.find(
        // eslint-disable-next-line no-underscore-dangle
        item => item?._id === tourId
    );
    useEffect(() => {
        // il precedente valore del top era 250 in quanto era presente anche il componente HeadSection
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, [sectionType]);
    return (
        <div className="minWidth100vwFromXL">
            {/* <HeadSection
                className="mb-5"
                content={headData}
                backgroundIsEmpty
            /> */}
            {/* E' stato aggiunto un marginTop di 120px per ottonere lo stesso effetto dello spazio occupato precedentemente dall'HeadSection */}
            <MDBRow
                className={`${styles.container} pb-3`}
                style={{
                    marginTop: "120px",
                }}
            >
                <MDBCol
                    size={12}
                    lg={5}
                    xl={3}
                    className="d-flex justify-content-start align-items-start h-100 p-lg-4"
                >
                    <Profile buttons={navigationElement} />
                </MDBCol>

                <ContentSectionLayout
                    title={title}
                    onClick={handleBookingNavigation}
                    buttonId={sectionType}
                    buttonBack="Go back to your bookings"
                >
                    {bookings &&
                        sectionType === EButtonBooking.YOURBOOKING &&
                        bookings?.map((item: BookingReadableTO) => (
                            <CardBooking
                                // eslint-disable-next-line no-underscore-dangle
                                key={item._id}
                                content={item}
                                onClick={handleMethodBooking}
                            />
                        ))}
                    {!bookings &&
                        sectionType === EButtonBooking.YOURBOOKING && (
                            <MDBRow className="w-100 justify-content-center my-5">
                                <p>Here you will find your purchased tours.</p>
                            </MDBRow>
                        )}
                    {sectionType === EButtonBooking.PAYMENTS &&
                        bookingSelected && (
                            // eslint-disable-next-line no-underscore-dangle
                            <PaymentSection bookingId={bookingSelected._id} />
                        )}

                    {sectionType === EButtonBooking.PERSONALINFO &&
                        bookingSelected && (
                            <PersonalInfoSection
                                // eslint-disable-next-line no-underscore-dangle
                                bookingId={bookingSelected._id}
                            />
                        )}
                </ContentSectionLayout>
            </MDBRow>
            <Help />
        </div>
    );
};

export default BookingBody;
